import L from "leaflet";
import { renderSchoolPinSvg, getPinDimensions } from "./renderSchoolPinSvg";
import {
  canUseFigmaPin,
  renderFigmaPinHtml,
  FIGMA_PIN_WIDTH,
  FIGMA_PIN_HEIGHT,
} from "./renderFigmaPin";
import { PIN_WIDTH } from "./markerConstants";

const cache = new Map();

function cacheKey({ gender, phase, ofstedGrade, isTopSchool, schoolType }) {
  const kind = canUseFigmaPin({ gender, ofstedGrade }) ? "figma" : "svg";
  return `${kind}|${gender}|${phase}|${ofstedGrade}|${isTopSchool ? 1 : 0}|${schoolType || ""}`;
}

/**
 * Returns a cached Leaflet divIcon for the given marker properties.
 * Boys/Girls/Mixed use Figma pin layers (all Ofsted grades); others keep SVG pins.
 */
export function getSchoolMarkerIcon(props) {
  const key = cacheKey(props);
  if (cache.has(key)) return cache.get(key);

  let icon;

  if (canUseFigmaPin(props)) {
    icon = L.divIcon({
      html: renderFigmaPinHtml(props),
      className: "v2-school-pin-icon v2-school-pin-figma",
      iconSize: [FIGMA_PIN_WIDTH, FIGMA_PIN_HEIGHT],
      iconAnchor: [FIGMA_PIN_WIDTH / 2, FIGMA_PIN_HEIGHT],
    });
  } else {
    const html = renderSchoolPinSvg(props);
    const { width, height } = getPinDimensions();
    icon = L.divIcon({
      html,
      className: "v2-school-pin-icon",
      iconSize: [width, height],
      iconAnchor: [PIN_WIDTH / 2, height],
    });
  }

  cache.set(key, icon);
  return icon;
}
